<template>
    <div class="vld-parent">
      <loading v-model:active="isLoading" :is-full-page="true" :height="128" :width="128"/>
    </div>

    <div class="title-container">
      <div class="title-text">Room Booking</div>
    </div>

    <div class="side-distance">

      <div class="full-page-content">
      </div>

    </div>

</template>
  <script>
    /* eslint-disable */
    import '@vuepic/vue-datepicker/dist/main.css'
    import {
    } from '@mdi/js'
    import {
      ref,
      onMounted,
      onBeforeMount,
      watchEffect
    } from 'vue'
    import { useStore } from 'vuex'
    import Loading from 'vue-loading-overlay'
    import 'vue-loading-overlay/dist/vue-loading.css'
    import CryptoJS from 'crypto-js'
    export default {
      name: 'HomeParent',
      components: {
        Loading
      },
      mounted () {
        // this.$refs['lazyVideo'].playVideo();
      },

      methods: {},
      props: {
        comment: Object,
        showEdit: {
          Boolean
        }
      },
      emits: ['close-modal', 'submit'],
      setup (props, {
        emit
      }) {
        const str = useStore()
        const isLoading = ref(false)

        const userLogin = localStorage.getItem('name')
        const userRole = localStorage.getItem('roles')
        const usernameLogin = localStorage.getItem('username')

        const checkUser = ref(false)
        const userCheck = () => {
          const decryptedMessage = CryptoJS.AES.decrypt(localStorage.getItem('role'), 'amatra1609').toString(CryptoJS.enc.Utf8)
          const myArray = decryptedMessage.split(',')
          for (let i = 0; i < myArray.length; i++) {
            if (myArray[i] === 'ROLE_ADMIN' || myArray[i] === 'ROLE_ADMIN_HRD') {
              checkUser.value = true
            }
          }
        }

        onMounted(() => {
          if (localStorage.getItem('reloaded')) {
            localStorage.removeItem('reloaded')
            userCheck()
          } else {
            localStorage.setItem('reloaded', '1')
            // location.reload()
          }
        })

        onBeforeMount(() => {})

        watchEffect(() => {})

        return {
          str,
          isLoading,
          userLogin,
          usernameLogin,
          checkUser,
          userCheck,
          userRole
        }
      }
    }
  </script>

  <style>
    @import '../../src/css/comboard.css';
    .search-header{
      position: relative;
      display: flex;
      gap: 15px;
      margin-bottom: 1rem;
      align-items: center;
    }
    .title-container{
      margin-right: 35px !important;
    }
    .side-distance{
      margin-right: 35px !important;
    }
    .comboards-wrapper{
      padding-right: 0px !important;
    }
    .reason.recalled{
      color: red;
      cursor: pointer;
      position: relative;
    }
    .reason.not-recalled{
      color: rgb(19, 168, 19);
    }
    .reason.recalled:hover{
      text-decoration: underline;
    }
    .modal-recall{
      position: absolute;
      z-index: 3;
      width: auto;
      background-color: #d9d9d9;
      top: 72px;
      left: 86px;
      height: 40px;
      border-radius: 0px;
      box-shadow: 0 3px 2px rgba(0,0,0,0.25);
      display: flex;
      align-items: center;
      padding: 12px;
      border: 1px solid rgba(0,0,0,0.5);
    }
    .modal-recall.shape-chat:before{
      content: "";
      position: absolute;
      width: 0;
      height: 0;
      border-top: 12px solid transparent;
      border-right: 12px solid rgba(0,0,0,0.5);
      border-bottom: 11px solid transparent;
      margin: -51px 0 0 -5px;
      transform: rotate(90deg);
    }
    .show{
      opacity: 100%;
      transform-origin: top right;
      transform: scale(1.0);
    }
    .hide{
      opacity: 0%;
      transform-origin: top right;
      transform: scale(0.0);
    }
    footer.footer-parent{
      z-index: 4;
    }
    .filter-wrapper{
      background: white;
      padding: 16px;
      border-radius: 0px;
      margin-bottom: 20px;
      box-shadow: 0px 2px 4px rgba(0,0,0,0.25);
    }
    .filter-selection{
      width: 100%;
    }
    .text-red{
      color: red;
    }
  </style>
